import React, { Fragment, useState, useRef } from "react";
import { Toast } from "react-bootstrap";
import FadeIn from 'react-fade-in';
import useFetchArticulo from "../hooks/use_fetch_articulo";
// Custom imports
import useFontSize from "../providers/use_font_settings";
import useLogin from "../providers/use_login";
import WikiNavBar from "../components/navbar";
import Footer from "../components/footer";
import HtmlParser from "../components/html_parser";
import Editor from "../components/editor";
import Loading from "../components/loading";
import EditButton from "../components/edit-button";
import ArticuloHeader from "../components/articulo-header";
import ArticuloMetadata from "../components/articulo-metadata";
import TinySad from "../components/tiny-sad"
import ShareArticulo from "../components/share-articulo";
import VeaseTambien from "../components/vease-tambien";

const ArticuloPage = ({ nombre }) => {
  const { articulo, isBusy } = useFetchArticulo(nombre);
  const { fontSize } = useFontSize();
  const { user } = useLogin();
  const [editMode, setEditMode] = useState(false);
  const [success, setSuccess] = useState(false);
  const topPage = useRef(null);


  if (isBusy)
    return (
      <Fragment>
        <WikiNavBar />
        <div style={{ marginTop: 32 }} />
        <Loading />
      </Fragment>
    );

  if (!articulo)
    return (
      <>
        <WikiNavBar />
        <FadeIn>
          <div className="container">
            <div style={{ marginTop: 32 }} />
            <TinySad />
            <br />
            <center><h4>El artículo solicitado "{nombre || ''}" no Existe</h4></center>
          </div>
        </FadeIn>
      </>
    );

  return (
    <Fragment>
      <WikiNavBar isSticky={editMode ? false : true} />
      <FadeIn>
      <div ref={topPage} style={{ height: 0 }} />
      {!editMode ? (
        <div className="container">
            {/* <FontsizeOptions /> */}
            <ArticuloHeader articulo={articulo} />
            <div style={{ marginTop: 16 }} />
            <ShareArticulo articulo={articulo} />
            <ArticuloMetadata articulo={articulo} />
            <div style={{ marginTop: 32 }} />
            <HtmlParser fontSize={fontSize} html={articulo?.html} />
            <VeaseTambien articulo={articulo} />
          {user && (
            <EditButton
              disabled={isBusy}
              onClick={() => {
                setEditMode(true);
                window.scrollTo(0, topPage.current.offsetTop);
              }}
            />
          )}
        </div>
      ) : (
        <div className="container">
          <div style={{ marginTop: 32 }} />
          <h2>Propuesta de Edición</h2>
          <p>
            Las ediciones que hagas serán enviadas al Staff del foro para su
            revisión. Contáctate primero con la administración antes de llenar
            este formulario, para asegurarte de que tu idea esté en línea con
            nuestro lore y planificación.
          </p>
          <Editor
            onSave={() => setSuccess(true)}
            onCancel={() => {
              setEditMode(false);
              window.scrollTo(0, topPage.current.offsetTop);
            }}
            articulo={articulo}
            />
        </div>
      )}
      </FadeIn>
      <Footer />
      <Toast
        style={{ position: "fixed", top: 25, right: 25 }}
        onClose={() => setSuccess(false)}
        show={success}
        delay={5000}
        autohide
      >
        <Toast.Header>
          <strong className="mr-auto">¡Propuesta Enviada!</strong>
        </Toast.Header>
        <Toast.Body>Ya hemos recibido tu propuesta.</Toast.Body>
      </Toast>
    </Fragment>
  );
};

export default ArticuloPage;
